export const getSection2 = async <_>(
  page: string,
): Promise<{
  finalData: any;
}> => {
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  let baseUrl = `${API_URL}${page}/content`;

  if (page == "events") {
    baseUrl = `${API_URL}/api/contact-page-s2-event?populate[events][populate][speaker_times][populate]=speaker`;
  }

  try {
    const response = await fetch(baseUrl);
    const data: any = await response.json();
    return {
      finalData: data,
    };
  } catch (error) {
    console.error(`Error fetching ${page} data:`, error);
    return {
      finalData: {},
    };
  }
};
